import { useEffect } from "react";

import { fetchModelSummary } from "../services/api";
import { useHorizonStore } from "../store/useHorizonStore";

const SUMMARY_POLL_MS = 6000;

export function useModelSummary(): { refreshSummary: () => Promise<void> } {
  const setModelSummary = useHorizonStore((state) => state.setModelSummary);
  const setModelSummaryError = useHorizonStore((state) => state.setModelSummaryError);
  const setModelSummaryLoading = useHorizonStore((state) => state.setModelSummaryLoading);

  const refreshSummary = async () => {
    setModelSummaryLoading();
    try {
      const summary = await fetchModelSummary();
      setModelSummary(summary);
    } catch (error) {
      setModelSummaryError(error instanceof Error ? error.message : "Failed to load model summary.");
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    setModelSummaryLoading();

    fetchModelSummary(abortController.signal)
      .then((summary) => {
        setModelSummary(summary);
      })
      .catch((error: unknown) => {
        if (abortController.signal.aborted) {
          return;
        }
        setModelSummaryError(error instanceof Error ? error.message : "Failed to load model summary.");
      });

    const interval = window.setInterval(() => {
      void refreshSummary();
    }, SUMMARY_POLL_MS);

    return () => {
      abortController.abort();
      window.clearInterval(interval);
    };
  }, [setModelSummary, setModelSummaryError, setModelSummaryLoading]);

  return { refreshSummary };
}
